import React from 'react'
import {
    PageTitleText,PageContainerTitleText
 } from '../../../../widget/styledComponents/headings.style';

import {
    SettingsContainer
} from './settings.style'
import SettingsTabWidget from './widgets/tab_widget';

function SettingsPageWidget() {
    

  return (
    <div className=''>
        <div className='row'>
            <div className='col s12 m3'>
                <PageTitleText>
                    {/* PalmVille  Estate */}
                </PageTitleText>
            </div>
            
        </div>  
        <SettingsContainer>
            <PageContainerTitleText>
                Settings
            </PageContainerTitleText>
            <SettingsTabWidget>
            </SettingsTabWidget>
        </SettingsContainer>
      
    </div>
  )
}

export default SettingsPageWidget